import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {withRouter} from 'react-router-dom'
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import ButtonBase from '@material-ui/core/ButtonBase';

import Typography from '@material-ui/core/Typography';

const styles = {
  description: {
      height: '100px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
  },
  cardAction: {
      display: 'block',
      width: 160,
  },
  card: {
    width: 160,
  },
  media: {
      height: 160,
      width: 160,

//    height: 0,
//    paddingTop: '56.25%', // 16:9
  },
};

class ClusterCard extends React.Component {
  state = {
      gender: 'Unknown'
  };


  componentWillMount() {
      const { cluster } = this.props;
      let f = 0;
      let m = 0;

      cluster.forEach(cl => {
          console.log(cl);
          if (cl.gender == 'M')
              m++;
          else if (cl.gender == 'F')
              f++;
      });

      if (m > f) {
          this.setState({ gender: 'Male' });
      } else if (f > m) {
          this.setState({ gender: 'Female' });
      }
      else {
          this.setState({ gender: 'Unknown' });
      }
  }

  render() {
      const { classes, cluster, video } = this.props;


      return (
        <div>
         {cluster && cluster.length > 0 && cluster[0].clustered_id && (
              <Card className={classes.card}>
                <ButtonBase
                    className={classes.cardAction}
                    onClick={event => this.props.history.push(`/video/${1}`)}
                >
                    <CardMedia
                      className={classes.media}
                      image={`https://s3.amazonaws.com/deeplearn-vision/cluster-gifs/${video.job_uuid}/${cluster[0].clustered_id}.gif`}
                      title={"Some title"}
                    />
                    <CardContent>
                      <Typography gutterBottom variant="headline" component="h2">#{cluster && cluster.length && cluster[0].clustered_id}</Typography>
                      <Typography variant="subheading">{cluster && cluster.length} pictures</Typography>
                      <Typography variant="subheading">Gender: {this.state.gender}</Typography>


                    </CardContent>
                </ButtonBase>
                          {/*<CardActions>
                  <Button size="small" color="primary">
                    Renditions
                  </Button>
                  <Button size="small" color="primary" disabled="disabled">
                    Entities
                  </Button>
                </CardActions>*/}
              </Card>
         )}
        </div>
      );
    }
}

ClusterCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles)(ClusterCard));



// WEBPACK FOOTER //
// ./src/components/cluster_card.jsx